<template>
<div class="chapter">
<div class="inner_page">
<section class="titlepage" epub:type="titlepage">
<div class="title"><img alt="The Soul Thief by Cecelia Holland" src="images/scale~1920x1200~soulpatch-1547589248-16.jpg"/></div>
<div class="canelo"><img alt="Canelo" height="30" src="images/scale~1920x1200~canelotitle-1454015556-29.png" style="height:30px;width:129px;" width="129"/></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter0.vue?7a8d9d08